<!--
 * @Author: LHB
 * @Date: 2022-06-11 17:46:35
 * @LastEditTime: 2022-07-23 09:58:00
 * @LastEditors: LHB
 * @Description: 
 * @FilePath: \shirleyClass\src\modules\BindLinkerror\index.vue
 * ---
-->
<template>
  <div class="wrap">
    <img class="none-icon" src="../../assets/images/non_icon.png" alt="" />
    <p class="none-title">很抱歉，该链接已失效！</p>
  </div>
</template>
<script>
import utils from '../../utils/index.js'
import wx_tools from '../common/wx_tools.js'

export default {
  name: 'bindLinkerror',
  components: {},
  data() {
    return {}
  },
  mounted() {
    document.title = '雪梨英语'
    console.log('??', utils)
    this.initShare()
  },
  watch: {},
  methods: {
    initShare() {
      console.log('调用initShare')
      const tempJumpLink = utils.config.config.shareUrl
      // 分享字数规则：主标题两行，副标题3行，超出全部...
      let shareObj = {
        debug: false,
        referer: tempJumpLink,
        appId: utils.config.config.appId,
        title: utils.config.config.shareMainTitle,
        desc: utils.config.config.shareDesTitle,
        link: tempJumpLink,
        imgUrl: utils.config.config.shareImgUrl,
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '' // 如果type是music或video，则要提供数据链接，默认为空
        // success: this.shareSuccess
        // fail: this.shareFail
      }
      console.log('分享跳转地址--login', shareObj)
      wx_tools.initShare.call(this, shareObj)
    }
  }
}
</script>

<style src="./index.css" scoped></style>
